module.exports = __webpack_public_path__ + "static/media/desi.dd8fb213.jpg";